import type { OnInit } from '@angular/core';
import { Component, Input, inject } from '@angular/core';
import { EnvService } from '@core-mkt/services/env/env.service';
import { ScriptLoaderService } from '@core-mkt/services/script-loader/script-loader.service';
import { ReferralPopupComponent } from '../referral-popup/referral-popup.component';
import { GladlyHelpCenter } from './gladly-help-center';

@Component({
  selector: 'gladly-help-center',
  templateUrl: './gladly-help-center.component.html',
  styleUrls: [],
  standalone: true,
  imports: [ReferralPopupComponent],
})
export class GladlyHelpCenterComponent implements OnInit {
  @Input() data: GladlyHelpCenter;
  private defaultDivSelector = 'gladly-help-center';

  private readonly scriptLoaderService = inject(ScriptLoaderService);
  private readonly env = inject(EnvService);

  ngOnInit() {
    if (this.data && this.data.showGladlyHelpCenter) {
      if (!this.data.gladlyBrandIdOverride || this.data.gladlyBrandIdOverride === null) {
        this.scriptLoaderService.injectScriptByType('gladly');
      } else {
        this.scriptLoaderService.injectScriptByType('gladly', this.data.gladlyBrandIdOverride);
      }
    }
  }

  get gladlyDivSelector(): string {
    return this.env.get.gladlyHelpCenterEnvironment.selector ?? this.defaultDivSelector;
  }

  get gladlyHelpCenterEnabled(): boolean {
    return this.data && this.data.showGladlyHelpCenter ? this.data.showGladlyHelpCenter : false;
  }
}
